import { defineRecipe } from '@plurall/elo-v3';

export const benchmarkingMecActionButtonRecipe = defineRecipe({
  className: 'benchmarking-mec-action-button',
  base: {},
});

export const benchmarkingMecActionsRecipe = defineRecipe({
  className: 'benchmarking-mec-actions',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'gap.medium',
    marginTop: 'padding.medium',
  },
});
